import { render } from "./AppInstrumentalTreatments.vue?vue&type=template&id=1d9bf2e3&scoped=true"
import script from "./AppInstrumentalTreatments.vue?vue&type=script&lang=js"
export * from "./AppInstrumentalTreatments.vue?vue&type=script&lang=js"

import "./AppInstrumentalTreatments.vue?vue&type=style&index=0&id=1d9bf2e3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\petr.hric\\Desktop\\MyDrive\\web\\mkosmeo\\mkosmeo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9bf2e3"]])

export default __exports__